// ABOUTME: Shared TipTap extension set replacing StarterKit with only what we use.
// ABOUTME: Reduces bundle size by excluding unused extensions (heading, codeBlock, blockquote, horizontalRule).

import { Document } from "@tiptap/extension-document";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Text } from "@tiptap/extension-text";
import { Bold } from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import { Strike } from "@tiptap/extension-strike";
import { Code } from "@tiptap/extension-code";
import { BulletList, OrderedList, ListItem, ListKeymap } from "@tiptap/extension-list";
import { HardBreak } from "@tiptap/extension-hard-break";
import { Dropcursor, Gapcursor, UndoRedo } from "@tiptap/extensions";
import { TextStyle } from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import FontSize from "./FontSize";
import FontWeight from "./FontWeight";

export const coreExtensions = [
    Document,
    Paragraph,
    Text,
    Bold,
    Italic,
    Strike,
    Code,
    BulletList,
    OrderedList,
    ListItem,
    ListKeymap,
    HardBreak,
    Dropcursor,
    Gapcursor,
    UndoRedo,
    TextStyle,
    Color,
    FontSize,
    FontWeight,
];
